__turbopack_context__.v({
  "captcha-text": "KEZM7a_captcha-text",
  "container": "KEZM7a_container",
  "hidden": "KEZM7a_hidden",
  "text": "KEZM7a_text",
});
